import { Build, AnnotationsTab } from "~/components/build/Show/lib/types";

export function getAnnotationCounts(build: Build): Record<AnnotationsTab, number> & {
  totalCount: number;
} {
  const buildCount = Object.values(build.annotationCountsByStyle).reduce(
    (sum, count) => sum + count,
    0,
  );
  const jobCount = Object.values(build.statistics?.jobAnnotationCountsByStyle || {}).reduce(
    (sum, count) => sum + count,
    0,
  );

  return {
    [AnnotationsTab.Build]: buildCount,
    [AnnotationsTab.Jobs]: jobCount,
    totalCount: buildCount + jobCount,
  };
}
